var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    directives: [{
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    staticClass: "mod",
    class: {
      padding: _vm.isBottomPaddingShow
    },
    style: _vm.style
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };